import { IForm } from 'core-components/classes/models/IForm'
import { BaseCrud } from 'core-components/types'

import { useBaseSource } from './useBaseSource'

//TODO: Change by useBaseSource
export function useSource<T = IForm, R = string | number>(
  source: BaseCrud<T, R>,
  caption: string | ((item: T) => string),
  emptyValueLabel?: { value: string; dropDownKey?: string },
  onDataLoad?: (items: T[]) => void
) {
  const { staticSource, data, isDataLoading } = useBaseSource<T, R>({
    source,
    caption,
    emptyValueLabel,
    onDataLoad,
  })

  return { staticSource, data, wip: isDataLoading }
}
